import React from 'react'
import PropTypes from 'prop-types'

import { FormProvider } from 'react-hook-form'
import { Box, Typography } from '@material-ui/core'

import ContactInformationFragment from 'artkive/components/Checkout/Sections/ContactInformationFragment'
import PersonalNameFragment from 'artkive/components/Checkout/Sections/PersonalNameFragment'
import SubmitButton from 'artkive/components/Checkout/SubmitButton'
import useInformationForm from 'artkive/components/Checkout/useInformationForm'

const ContactInformation = ({ onSubmit, productType, product }) => {
  const { handleFormSubmit, ...methods } = useInformationForm(product, onSubmit)
  const {
    formState: { isValid },
  } = methods

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleFormSubmit}>
        <Box mb={2}>
          <Typography variant='h6'>Contact Information</Typography>
        </Box>

        <PersonalNameFragment />

        <ContactInformationFragment
          // TODO: fix form submit tracking tracking - given props are ignored
          productType={productType}
          formType='information'
        />

        <SubmitButton disabled={!isValid}>Continue To Payment</SubmitButton>
      </form>
    </FormProvider>
  )
}

ContactInformation.propTypes = {
  onSubmit: PropTypes.func,
  productType: PropTypes.string,
  product: PropTypes.object,
}

export default ContactInformation
